import { CSV_IMPORT_KEYS } from './csvImportConfig';

export const TENANT_NODE_TABS = [
  {
    key: 'facilities',
    labelKey: 'tenantTabFacilities',
    importKey: CSV_IMPORT_KEYS.facilities,
    pageTab: 'facilities',
  },
  {
    key: 'products',
    labelKey: 'tenantTabProducts',
    importKey: CSV_IMPORT_KEYS.products,
    pageTab: 'products',
  },
  {
    key: 'logistics',
    labelKey: 'tenantTabLogistics',
    importKey: CSV_IMPORT_KEYS.logistics,
    pageTab: 'logistics',
  },
  {
    key: 'geographies',
    labelKey: 'tenantTabGeographies',
    importKey: CSV_IMPORT_KEYS.geographies,
    pageTab: 'geographies',
  },
  {
    key: 'commodities',
    labelKey: 'tenantTabCommodities',
    importKey: CSV_IMPORT_KEYS.commodities,
    pageTab: 'commodities',
  },
  {
    key: 'supplierFacilities',
    labelKey: 'tenantTabSupplierFacilities',
    importKey: CSV_IMPORT_KEYS.supplierFacilities,
    pageTab: 'supplierFacilities',
  },
  {
    key: 'graphRelationships',
    labelKey: 'tenantTabGraphRelationships',
    importKey: CSV_IMPORT_KEYS.graphOverview,
    pageTab: 'graphRelationships',
  },
];

export const TENANT_DATA_HUB_TAB = 'data';
export const TENANT_DATA_IMPORT_SECTION = 'import';

/** Node keys needed for map rendering (prefetch when Map tab is active). */
export const TENANT_MAP_NODE_KEYS = [
  'facilities',
  'supplierFacilities',
  'geographies',
  'logistics',
  'graphRelationships',
];

export const TENANT_PAGE_TABS = [
  { key: 'map', labelKey: 'tenantTabMap' },
  { key: 'overview', labelKey: 'tenantTabOverview' },
  { key: 'analysis', labelKey: 'tenantTabAnalysis' },
  { key: TENANT_DATA_HUB_TAB, labelKey: 'tenantTabSupplyChainData' },
];

export const isNodePageTab = (tabKey) =>
  TENANT_NODE_TABS.some((tab) => tab.pageTab === tabKey);

export const isDataImportSection = (section) => section === TENANT_DATA_IMPORT_SECTION;

export const resolvePrimaryTab = (activeTab) => {
  if (
    isNodePageTab(activeTab) ||
    activeTab === TENANT_DATA_HUB_TAB ||
    activeTab === TENANT_DATA_IMPORT_SECTION
  ) {
    return TENANT_DATA_HUB_TAB;
  }
  return activeTab;
};

export const resolveDataSubTab = (activeTab, fallback = TENANT_NODE_TABS[0]?.pageTab) => {
  if (isDataImportSection(activeTab)) return TENANT_DATA_IMPORT_SECTION;
  if (isNodePageTab(activeTab)) return activeTab;
  return fallback;
};

export const getNodeTabByKey = (key) => TENANT_NODE_TABS.find((tab) => tab.key === key);

export const getNodeTabByPageTab = (pageTab) =>
  TENANT_NODE_TABS.find((tab) => tab.pageTab === pageTab);
